import { render, staticRenderFns } from "./PlatformStatList.vue?vue&type=template&id=e387730a&scoped=true"
import script from "./PlatformStatList.vue?vue&type=script&lang=js"
export * from "./PlatformStatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e387730a",
  null
  
)

export default component.exports